import { render, staticRenderFns } from "./FileModalModern.vue?vue&type=template&id=16413a57&scoped=true"
import script from "./FileModalModern.vue?vue&type=script&lang=js"
export * from "./FileModalModern.vue?vue&type=script&lang=js"
import style0 from "./FileModalModern.vue?vue&type=style&index=0&id=16413a57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16413a57",
  null
  
)

export default component.exports